import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IFairePay) {
    (function(EnrolmentState) {
        EnrolmentState["ENROLMENT_STATE_UNKNOWN"] = "ENROLMENT_STATE_UNKNOWN";
        EnrolmentState["PRE_ENROLLED"] = "PRE_ENROLLED";
        EnrolmentState["PRE_ENROLLED_CHECKED_OUT"] = "PRE_ENROLLED_CHECKED_OUT";
        EnrolmentState["FULLY_ENROLLED"] = "FULLY_ENROLLED";
    })(IFairePay.EnrolmentState || (IFairePay.EnrolmentState = {}));
    (function(State) {
        State["STATE_UNKNOWN"] = "STATE_UNKNOWN";
        State["ACTIVE"] = "ACTIVE";
        State["DEFAULTED"] = "DEFAULTED";
        State["CLOSED"] = "CLOSED";
    })(IFairePay.State || (IFairePay.State = {}));
    (function(PaymentPreference) {
        PaymentPreference["PAYMENT_PREFERENCE_UNKNOWN"] = "PAYMENT_PREFERENCE_UNKNOWN";
        PaymentPreference["STATEMENT_BALANCE"] = "STATEMENT_BALANCE";
        PaymentPreference["MINIMUM_PAYMENT"] = "MINIMUM_PAYMENT";
        PaymentPreference["MANUAL"] = "MANUAL";
    })(IFairePay.PaymentPreference || (IFairePay.PaymentPreference = {}));
    IFairePay.build = function(partial) {
        return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
    };
})(IFairePay || (IFairePay = {}));
export var IFairePay;
